import React from 'react';

const SectionHeading = ({ eyebrow, title, description, align = 'left' }) => (
  <div className={`section-heading section-heading-${align}`}>
    {eyebrow ? <p className="section-eyebrow">{eyebrow}</p> : null}
    <h2>{title}</h2>
    {description ? <p className="section-description">{description}</p> : null}
  </div>
);

export default SectionHeading;
